// API Configuration
// Switch between local and deployed backend

// For deployed backend (Render):
export const API_URL = 'https://api.infloir.online';

// For local backend (uncomment when developing locally):
// export const API_URL = 'http://localhost:8080';